// Core packages
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

// Third party packages
import { KeyValue } from "@angular/common";
import { MatDialog } from "@angular/material";
import { Sort } from "@angular/material/sort";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";

// Custom packages
import { AccessLogsService } from "src/app/modules/access-logs/access-logs.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { Property } from "src/app/shared/models/property/property.model";
import { VideoViewInterface } from "src/app/shared/models/video-view/video-view.interface";
import { ConfigService } from "src/app/shared/services/config.service";
import { FireSafetyDocsService } from "src/app/shared/services/fire-safety-docs.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { PrivacyStudioDocsService } from "src/app/shared/services/privacy-studio-docs.service";
import { VideoViewService } from "src/app/shared/services/video-view.service";
import { GenericDocsService } from "../../modules/generic-docs/generic-docs.service";
import { DocumentDownloadDialogComponent } from "../../modules/properties/components/document-download-dialog/document-download-dialog.component";
import { CondoStructuresService } from "../../modules/properties/condo-structures.service";
import { DocumentArchivesService } from "../../modules/properties/document-archives.service";
import { AllDocsInterface } from "../../modules/properties/documents.interface";
import DocumentTypeStructure from "../../modules/properties/documentTypes";

@Component({
  selector: "public-qrcode",
  templateUrl: "./publicQRCode.component.html",
  styleUrls: ["./publicQRCode.component.scss"],
})
export class PublicQRCodeComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  lang = this.translateService.currentLang || this.translateService.defaultLang;

  public property: Property = new Property();

  // BEGIN - Add property form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  // END - ngx-formly
  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant(
      "qrcode.viewPage.form.submitButtonText"
    ),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-sign-in",
      inline: true,
    },
  };
  // END - Add property form

  pageIsLoaded = false;

  formUserData = false;
  propertyId = "";
  documentId = "";

  isFireSafetyDoc = false;
  isGenericDoc = false;
  isPrivacyStudioDoc = false;
  isVideo = false;
  isVideoOld = false;
  isSafetyVideoSuppliers = false;
  isSafetyVideoResidents = false;
  isDoc = false;
  isDocsSection = false;
  isDocsSectionOld = false;
  showVideo = false;
  showVideoResident = false;
  showVideoSupplier = false;
  showDoc = false;
  showDocSection = false;

  genericDoc: any;
  fireSafetyDoc: any;
  privacyStudioDoc: any;

  condoStructure: any;
  documentArchive: any;
  allDocs: AllDocsInterface[] = [];
  displayedDocs: AllDocsInterface[] = [];

  currentOriginalOrder: any;

  sortActive = false;

  companyId = "";

  // query string section QR code from App
  firstName = "";
  lastName = "";
  companyName = "";
  forceSubmit = false;

  documentTemplateId = "";
  documentTemplate: any[] = [];

  insertedDocs: any[] = [];
  public documentTypeStructure: DocumentTypeStructure =
    new DocumentTypeStructure();

  master: '';
  showMasterVideoResident = false;
  mastersVideoResident: string[] = [
    '63592efd6a8bbf24104c0e16',
    '666ad1b2ee17cc075eff0301'
  ];

  /**
   * Class constructor
   */
  constructor(
    public dialog: MatDialog,
    public helperService: HelperService,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private propertiesService: PropertiesService,
    public configService: ConfigService,
    private accessLogsService: AccessLogsService,
    private condoStructuresService: CondoStructuresService,
    private documentArchivesService: DocumentArchivesService,
    private toastrService: ToastrService,
    private settingsService: SettingsService,
    private genericDocsService: GenericDocsService,
    private videoViewService: VideoViewService,
    private fireSafetyDocsService: FireSafetyDocsService,
    private companiesService: CompaniesService,
    private privacyStudioDocsService: PrivacyStudioDocsService,
  ) {}

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Subscribe to current lang and init component
    this.translateService.use("it");

    // Video da piattaforma 1
    // /qrcode/600e2164-861f-11e6-849f-000c29dd368f/videoext

    // Singolo documento generico, quindi senza la struttura
    // /qrcode/5f8d4975a2a02e1a9488b898/gest-amm-tivo-gestionali/generic/AC2/5ffdcece2c5484787558f187
    // 5f8d4975a2a02e1a9488b898 = id archviodocumenti
    // 5fd499c20ad99956dc4629e0 = id del subdocument

    // Singolo documento legato a un struttura
    // /qrcode/5f7dcdbf2489c53ab08bad07/gest-amm-tivo-dipendenti/5fd499c30ad99956dc4629f0/AA1/5fd499c30ad99956dc4629f1
    // 5f7dcdbf2489c53ab08bad07 = id archviodocumenti
    // 5fd499c30ad99956dc4629f0 = id document
    // 5fd499c30ad99956dc4629f1 = id del subdocument

    // Area archivio
    // /qrcode/5f7dcdbf2489c53ab08bad07/docstructure/gestionaleAmministrativo
    // 5f7dcdbf2489c53ab08bad07 = id archviodocumenti

    // Area sub archivio
    // /qrcode/5f8d4d7b59ef783bdc11fea2/docsubstructure/gestionaleAmministrativo/gestAmmTivoSicurezza
    // 5f8d4d7b59ef783bdc11fea2 = id archviodocumenti

    // Area sub archivio and only one structure
    // /qrcode/5f8d4975a2a02e1a9488b898/docsubstructure/ascensoriEMontauto/ascensoriEMontautoAscensori/5fb4dbc1b1d85e7478c33abc
    // 5f8d4975a2a02e1a9488b898 = id archviodocumenti

    // Area archivio piattaforma 1
    // https://app.archedi.it/buildings/showDocs/f4a0c2b4-dd08-11e8-a685-000c29dd368f/104/5bfd7f7b-2c7c-46af-9c2d-781ec0a8506a/
    // f4a0c2b4-dd08-11e8-a685-000c29dd368f = idold property
    // 104 = categoria documento => Impianto elettrico generale

    if (
      this.activatedRoute.snapshot.url &&
      this.activatedRoute.snapshot.url.length > 2
    ) {
      const query = this.activatedRoute.snapshot.queryParams;
      switch (this.activatedRoute.snapshot.url[2].path) {
        case "fireSafetyDoc": 
          this.isFireSafetyDoc = true;
          this.formUserData = false;
          break;
        case "genericDoc":
          this.isGenericDoc = true;
          this.formUserData = false;
          break;
        case "privacyStudioDoc":
          this.isPrivacyStudioDoc = true;
          this.formUserData = false;
          break;
        case "video":
          this.isVideo = true;
          if (query) {
            this.firstName = query.firstName ? query.firstName : "";
            this.lastName = query.lastName ? query.lastName : "";
            this.companyName = query.companyName ? query.companyName : "";
            if (this.firstName && this.lastName && this.companyName) {
              this.forceSubmit = true;
            }
          }
          break;
        case "videoext":
          this.isVideo = true;
          this.isVideoOld = true;
          break;
        case "safetyVideoSuppliers": 
          this.isSafetyVideoSuppliers = true;
          break;
        case "safetyVideoResidents":
          this.isSafetyVideoResidents = true;
          break;
        case "docstructure":
          this.isDocsSection = true;
          if (query) {
            this.firstName = query.firstName ? query.firstName : "";
            this.lastName = query.lastName ? query.lastName : "";
            this.companyName = query.companyName ? query.companyName : "";
            if (this.firstName && this.lastName && this.companyName) {
              this.forceSubmit = true;
            }
          }
          break;
        case "docsubstructure":
          this.isDocsSection = true;
          if (query) {
            this.firstName = query.firstName ? query.firstName : "";
            this.lastName = query.lastName ? query.lastName : "";
            this.companyName = query.companyName ? query.companyName : "";
            if (this.firstName && this.lastName && this.companyName) {
              this.forceSubmit = true;
            }
          }
          break;
        case "docstructureext":
          this.isDocsSection = true;
          this.isDocsSectionOld = true;
          break;
        default:
          this.isDoc = true;
          break;
      }
    }

    if (this.isFireSafetyDoc) {
      const { documentId } = this.activatedRoute.snapshot.params;

      this.subscriptions.push(
        this.fireSafetyDocsService.getDocByView(documentId).subscribe((res) => {
          if (res.status) {
            this.fireSafetyDoc = res.data;
          }
        })
      );
    }

    if (this.isGenericDoc) {
      const { documentId } = this.activatedRoute.snapshot.params;

      this.subscriptions.push(
        this.genericDocsService.getDocByView(documentId).subscribe((res) => {
          if (res.status) {
            this.genericDoc = res.data;
          }
        })
      );
    }

    if (this.isPrivacyStudioDoc) {
      const { documentId } = this.activatedRoute.snapshot.params;

      this.subscriptions.push(
        this.privacyStudioDocsService.getDocByView(documentId).subscribe((res) => {
          if (res.status) {
            this.privacyStudioDoc = res.data;
          }
        })
      );
    }

    if (this.isVideo) {
      const { propertyId } = this.activatedRoute.snapshot.params;

      if (this.isVideoOld) {
        // Get property from old Id
        this.subscriptions.push(
          this.propertiesService.getByOldId(propertyId).subscribe((res) => {
            if (res.status) {
              if (res.propertyId) {
                this.propertyId = res.propertyId;
                this.formUserData = true;

                this.initForm();
              }
            }
          })
        );
      } else {
        this.propertyId = propertyId;

        // const { t } = this.activatedRoute.snapshot.queryParams;

        // if (t) {
        //   // check token validation
        //   this.subscriptions.push(
        //     this.propertiesService
        //       .getVideoVisitByToken(this.propertyId, t)
        //       .subscribe((res) => {
        //         if (res.status) {
        //           if (res.item && Array.isArray(res.item) && res.item.length) {
        //             if (res.item[0].createdAt) {
        //               const today = moment();
        //               const createdAt = moment(res.item[0].createdAt);
        //               if (today.diff(createdAt, "hours") > 8) {
        //                 this.formUserData = true;
        //                 this.initForm();
        //               } else {
        //                 this.showVideo = true;
        //               }
        //             } else {
        //               this.formUserData = true;
        //               this.initForm();
        //             }
        //           } else {
        //             this.formUserData = true;
        //             this.initForm();
        //           }
        //         } else {
        //           this.formUserData = true;
        //           this.initForm();
        //         }
        //       })
        //   );
        // } else {
        //   this.formUserData = true;

        //   this.initForm();
        // }

        this.formUserData = true;
        this.initForm();
      }
    }

    if (this.isSafetyVideoSuppliers || this.isSafetyVideoResidents) {
      const { companyId } = this.activatedRoute.snapshot.params;
      this.companyId = companyId;

      // Scanning the QR must show the video right away: skip the user-data form
      // and do not track the view (no firstName/lastName/companyName collected).
      this.formUserData = false;
      if (this.isSafetyVideoResidents) {
        this.showVideoResident = true;
      } else {
        this.showVideoSupplier = true;
      }

      if (
        this.isSafetyVideoResidents &&
        this.mastersVideoResident.includes(this.companyId)
      ) {
        // Master residents keep showing the company name + ANACI badge above the video.
        this.showMasterVideoResident = true;
        this.subscriptions.push(
          this.companiesService
            .getBaseData(this.companyId)
            .subscribe((res) => {
              if (res.status) {
                this.master = res.data.name;
              }
            })
        );
      }
    }

    if (this.isDocsSection) {
      if (this.isDocsSectionOld) {
        const { propertyId, sectionold } = this.activatedRoute.snapshot.params;
        //  gestionaleAmministrativo
        //  catasto
        //  urbanisticaEdEdilizia
        //  reportistica
        //  stackingPlan
        //  lineaVita
        //  amiantoDoc
        //  edile
        //  impiantoElettrico
        //  riscaldamentoCondizionamento
        //  ascensoriEMontauto
        //  trattamentoAcqua
        //  impiantiElettronici
        //  attivitaSottopostePrevenzioneIncendi
        //  impiantiAntincendio
        //  impiantiSpeciali
        //  impiantiRicreativiSportivi
        //  unitaImmobiliari
        let section = "gestionaleAmministrativo";
        switch (sectionold) {
          case "1":
            section = "riscaldamentoCondizionamento";
            break; // "Riscaldamento centralizzato"
          case "3":
            section = "riscaldamentoCondizionamento";
            break; // "Bruciatori"
          case "4":
            section = "riscaldamentoCondizionamento";
            break; // "Serbatoio gasolio"
          case "5":
            section = "riscaldamentoCondizionamento";
            break; // "Gas metano - contatori e rete"
          case "6":
            section = "riscaldamentoCondizionamento";
            break; // "Sottostazioni riscaldamento"
          case "7":
            section = "riscaldamentoCondizionamento";
            break; // "Canne fumarie ad uso esclusivo centrale termica"
          case "8":
            section = "riscaldamentoCondizionamento";
            break; // "Impianti per la produzione acqua calda sanitari da solare termico"
          case "9":
            section = "riscaldamentoCondizionamento";
            break; // "Centrale di ricevimento da teleriscaldamento	"
          case "10":
            section = "riscaldamentoCondizionamento";
            break; // "Riscaldamento con sonde geotermiche e pompe di calore"
          case "11":
            section = "riscaldamentoCondizionamento";
            break; // "Riscaldamento con sole pompe di calore"
          case "12":
            section = "riscaldamentoCondizionamento";
            break; // "Centrale di ricevimento riscaldamento da altro condominio/BSC"
          case "13":
            section = "riscaldamentoCondizionamento";
            break; // "Centrale di ricevimento riscaldamento da supercondominio"
          case "14":
            section = "riscaldamentoCondizionamento";
            break; // "Impianto di condizionamento"
          case "15":
            section = "trattamentoAcqua";
            break; // "Centrale idrica"
          case "16":
            section = "trattamentoAcqua";
            break; // "Sottostazione idrica alimentata da altro condominio"
          case "17":
            section = "trattamentoAcqua";
            break; // "Sottostazione idrica alimentata da BSC"
          case "18":
            section = "trattamentoAcqua";
            break; // "Pompe sollevamento acque piovane/nere"
          case "19":
            section = "trattamentoAcqua";
            break; // "Pompe sollevamento acque nere"
          case "20":
            section = "gestionaleAmministrativo";
            break; // "Dipendenti"
          case "21":
            section = "gestionaleAmministrativo";
            break; // "Gestione dipendenti"
          case "22":
            section = "gestionaleAmministrativo";
            break; // "Gestionali"
          case "23":
            section = "impiantoElettrico";
            break; // "Potenza totale impegnata per l'impianto elettrico alimentato in BT/MT 230/400V inferiore o uguale a 6KW"
          case "24":
            section = "impiantoElettrico";
            break; // "Potenza totale impegnata per l'impianto elettrico alimentato in BT/MT 230/400V superiore a 6KW"
          case "25":
            section = "impiantoElettrico";
            break; // "Impianto elettrico alimentato da propria cabina in media tensione"
          case "26":
            section = "impiantoElettrico";
            break; // "Impianto fotovoltaico inferiore o uguale a 20KW"
          case "27":
            section = "impiantoElettrico";
            break; // "Impianto Fotovoltaico > 20KW"
          case "28":
            section = "impiantoElettrico";
            break; // "Gruppo elettrogeno"
          case "29":
            section = "impiantoElettrico";
            break; // "Impianto di protezione delle scariche atmosferiche"
          case "30":
            section = "ascensoriEMontauto";
            break; // "Ascensori"
          case "31":
            section = "ascensoriEMontauto";
            break; // "Montauto"
          case "32":
            section = "impiantiElettronici";
            break; // "Impianto centralizzato TV terrestre"
          case "33":
            section = "impiantiElettronici";
            break; // "Impianto centralizzato TV satellitare"
          case "34":
            section = "impiantiElettronici";
            break; // "Impianto citofonico/video"
          case "35":
            section = "impiantiElettronici";
            break; // "Impianto TVCC"
          case "36":
            section = "impiantiElettronici";
            break; // "Impianto automazione cancelli e simili"
          case "37":
            section = "impiantiElettronici";
            break; // "Impianto antintrusione"
          case "38":
            section = "impiantoElettrico";
            break; // "Impianto elettrico "
          case "39":
            section = "impiantiElettronici";
            break; // "Impianto antintrusione"
          case "40":
            section = "trattamentoAcqua";
            break; // "Impianti idrico/sanitari"
          case "41":
            section = "riscaldamentoCondizionamento";
            break; // "Impianti termici"
          case "42":
            section = "riscaldamentoCondizionamento";
            break; // "Impianti di condizionamento"
          case "43":
            section = "gestionaleAmministrativo";
            break; // "Ape - Prestazione energetica"
          case "44":
            section = "gestionaleAmministrativo";
            break; // "Elaborati grafici"
          case "45":
            section = "riscaldamentoCondizionamento";
            break; // "Canne fumarie singola unità immobiliare"
          case "46":
            section = "gestionaleAmministrativo";
            break; // "Amianto fabbricati"
          case "47":
            section = "gestionaleAmministrativo";
            break; // "APE - attestato di prestazione energetica"
          case "48":
            section = "lineaVita";
            break; // "Linea vita"
          case "49":
            section = "gestionaleAmministrativo";
            break; // "Documenti di costruzione dell'edificio/i"
          case "50":
            section = "edile";
            break; // "Compartimentazione REI murature"
          case "51":
            section = "edile";
            break; // "Porte REI"
          case "52":
            section = "edile";
            break; // "Interventi successivi alla costruzione dell'edificio"
          case "53":
            section = "gestionaleAmministrativo";
            break; // "Eleborati grafici/planimetrie"
          case "54":
            section = "riscaldamentoCondizionamento";
            break; // "Canne fumarie collettive ramificate"
          case "55":
            section = "impiantiRicreativiSportivi";
            break; // "Piscina"
          case "56":
            section = "impiantiRicreativiSportivi";
            break; // "Palestra"
          case "57":
            section = "impiantiRicreativiSportivi";
            break; // "Campo da tennis"
          case "58":
            section = "impiantiRicreativiSportivi";
            break; // "Campo da calcio/calcetto"
          case "59":
            section = "impiantiRicreativiSportivi";
            break; // "Parco giochi"
          case "60":
            section = "impiantiAntincendio";
            break; // "Estintori"
          case "61":
            section = "impiantiAntincendio";
            break; // "Rete idranti"
          case "62":
            section = "impiantiAntincendio";
            break; // "Rete sprinkler"
          case "63":
            section = "impiantiAntincendio";
            break; // "Stazione di pompaggio per rete antincendio"
          case "64":
            section = "impiantiAntincendio";
            break; // "Rilevazione fumo/incendio e/o CO e/o benzene e/o miscele esplosive"
          case "65":
            section = "impiantiAntincendio";
            break; // "Rilevazione fumo/incendio e/o CO e/o benzene e/o miscele esplosive"
          case "66":
            section = "impiantiAntincendio";
            break; // "Rilevazione fumo/incendio e/o CO e/o benzene e/o miscele esplosive"
          case "67":
            section = "impiantiAntincendio";
            break; // "Ventilazione meccanica per estrazione"
          case "68":
            section = "impiantiAntincendio";
            break; // "Ventilazione meccanica per immissione"
          case "69":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "VVF Vecchio Regolamento"
          case "70":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "VV.F. NUOVO REGOLAMENTO Att. 49-74-75-77 "
          case "71":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "VV.F. NUOVO REGOLAMENTO Att. 49-74-75-77 Cat. ""B"""
          case "72":
            section = "v";
            break; // "VV.F. NUOVO REGOLAMENTO Att. 49-74-75-77 Cat. ""C"""
          case "73":
            section = "gestionaleAmministrativo";
            break; // "Banca"
          case "74":
            section = "gestionaleAmministrativo";
            break; // "Cause legali / Accertamenti e contenziosi"
          case "75":
            section = "amiantoDoc";
            break; // "Amianto scale"
          case "76":
            section = "amiantoDoc";
            break; // "Amianto box"
          case "77":
            section = "amiantoDoc";
            break; // "Amianto giardini"
          case "78":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "V.V.F. NUOVO REGOLAMENTO"
          case "80":
            section = "gestionaleAmministrativo";
            break; // "Contratti forniture e servizi"
          case "81":
            section = "amiantoDoc";
            break; // "Amianto"
          case "83":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 49 Cat. ""A"""
          case "84":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 74 Cat. ""A"""
          case "85":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 75 Cat. ""A"""
          case "87":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 77 Cat. ""A"""
          case "88":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 49 Cat. ""B"""
          case "89":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // " Att. 74 Cat. ""B"""
          case "90":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 75 Cat. ""B"""
          case "92":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 77 Cat. ""B"""
          case "93":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 49 Cat. ""C"""
          case "94":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 74 Cat. ""C"""
          case "95":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Att. 75 Cat. ""C"""
          case "96":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "VVF Nuovo Regolamento"
          case "98":
            section = "impiantiAntincendio";
            break; // "Rete Sprinkler Box"
          case "99":
            section = "gestionaleAmministrativo";
            break; // "Dipendenti/annuali"
          case "100":
            section = "gestionaleAmministrativo";
            break; // "Gestione dipendenti/ annuali"
          case "101":
            section = "gestionaleAmministrativo";
            break; // "Gestionali annuali"
          case "103":
            section = "unitaImmobiliari";
            break; // "Unita abitative e Commerciali"
          case "104":
            section = "impiantoElettrico";
            break; // "Impianto elettrico generale"
          case "106":
            section = "trattamentoAcqua";
            break; // "Rete idrica sanitaria"
          case "107":
            section = "impiantiSpeciali";
            break; // "Impianto supplementare"
          case "108":
            section = "gestionaleAmministrativo";
            break; // "Atto di acquisto/vendita/provenienza"
          case "109":
            section = "gestionaleAmministrativo";
            break; // "Vincoli e diritti"
          case "111":
            section = "gestionaleAmministrativo";
            break; // "Ipoteche"
          case "112":
            section = "gestionaleAmministrativo";
            break; // "Titolarietà"
          case "113":
            section = "catasto";
            break; // "Catasto terreni"
          case "114":
            section = "catasto";
            break; // "Catasto fabbricati"
          case "115":
            section = "urbanisticaEdEdilizia";
            break; // "Urbanistica ed edilizia"
          case "116":
            section = "gestionaleAmministrativo";
            break; // "Condoni"
          case "117":
            section = "gestionaleAmministrativo";
            break; // "Autorizzazioni"
          case "118":
            section = "edile";
            break; // "Strutture"
          case "119":
            section = "gestionaleAmministrativo";
            break; // "Contratti di locazione"
          case "120":
            section = "gestionaleAmministrativo";
            break; // "Sicurezza"
          case "121":
            section = "gestionaleAmministrativo";
            break; // "Assicurazioni"
          case "122":
            section = "gestionaleAmministrativo";
            break; // "Documenti amministrativi"
          case "123":
            section = "reportistica";
            break; // "Reportistica"
          case "124":
            section = "gestionaleAmministrativo";
            break; // "Sicurezza"
          case "125":
            section = "riscaldamentoCondizionamento";
            break; // "Serbatoio a gasolio dismesso"
          case "126":
            section = "trattamentoAcqua";
            break; // "Contatore acqua"
          case "127":
            section = "stackingPlan";
            break; // "Stacking Plan"
          case "128":
            section = "gestionaleAmministrativo";
            break; // "Valutazione fornitori"
          case "129":
            section = "attivitaSottopostePrevenzioneIncendi";
            break; // "Attività sottoposte ai controlli prevenzione incendi"
          case "130":
            section = "edile";
            break; // "Rete fognaria"
        }

        // Get property from old Id
        this.subscriptions.push(
          this.propertiesService.getByOldId(propertyId).subscribe((res) => {
            if (res.status) {
              if (res.propertyId) {
                this.propertyId = res.propertyId;
                this.documentId = res.documentArchiveId;
                this.formUserData = true;

                this.subscriptions.push(
                  this.documentArchivesService
                    .getQrcode(this.documentId)
                    .subscribe(
                      (res) => {
                        if (res.status) {
                          this.documentArchive = res.data;
                          this.condoStructuresService
                            .getQrcode(res.data.structureId)
                            .subscribe((res) => {
                              if (res.status) {
                                this.condoStructure = res.data;
                                this.companyId = res.data.companyId;

                                this.subscriptions.push(
                                  this.settingsService.getDocument().subscribe(
                                    (res) => {
                                      if (res.status) {
                                        if (
                                          res.data &&
                                          Array.isArray(res.data) &&
                                          res.data.length > 0 &&
                                          res.data[0].area &&
                                          Array.isArray(res.data[0].area)
                                        ) {
                                          this.documentTemplateId = res.data[0]._id;
                                          this.documentTemplate = res.data[0].area;
                  
                                          this.allDocs = this.documentTypeStructure.getDocumentArchiveData(
                                            "it", // this.lang, 
                                            this.documentTemplate, 
                                            this.condoStructure, 
                                            this.documentArchive,
                                            "FULL", // this.subscriptionType,
                                            this.insertedDocs,
                                          );

                                          this.formUserData = true;
                                          this.initForm();

                                          this.displayedDocs = this.allDocs.filter((docs: any) => {
                                            const title = docs.keyTranslateTitle.replace("properties.documents.", "");
                                            // filter missing docs and deleted structure
                                            if (title === section) {
                                              
                                                const contents = docs.content;
                                                if (contents && Array.isArray(contents)) {
                                                  for (const item of contents) {
                                                    const subContents = item.content;
                                                    const displaySubContents: any[] = [];
                                                    if (subContents && Array.isArray(subContents)) {
          
                                                      for (const subItem of subContents) {
                                                        if (subItem.structureId && subItem.structureId !== ""){
                                                          if (subItem.active) {
                                                            let subSubContent = subItem.content;
                                                            if (subSubContent && Array.isArray(subSubContent)) {
                                                              subSubContent = subSubContent.filter((subSubItem: any) => {
                                                                return !subSubItem.deleted &&
                                                                // !subSubItem.contract &&
                                                                !subSubItem.expired &&
                                                                subSubItem.data && 
                                                                subSubItem.data.document &&
                                                                Array.isArray(subSubItem.data.document) &&
                                                                subSubItem.data.document.length > 0;
                                                              });
                                                            }
                                                            if (subSubContent.length > 0) {
                                                              subItem.content = subSubContent;
                                                              displaySubContents.push(subItem); 
                                                            }
                                                          }
                                                        } else if (subItem.type === "title" && subItem.content && Array.isArray(subItem.content)) {
                                                          const subSubContent = subItem.content.filter((subSubItem: any) => {
                                                            return !subSubItem.deleted &&
                                                              !subSubItem.expired &&
                                                              subSubItem.data &&
                                                              subSubItem.data.document &&
                                                              Array.isArray(subSubItem.data.document) &&
                                                              subSubItem.data.document.length > 0;
                                                          });
                                                          if (subSubContent.length > 0) {
                                                            subItem.content = subSubContent;
                                                            displaySubContents.push(subItem);
                                                          }
                                                        } else {
                                                          if (
                                                            !subItem.deleted &&
                                                            // !subItem.contract &&
                                                            !subItem.expired &&
                                                            subItem.data &&
                                                            subItem.data.document &&
                                                            Array.isArray(subItem.data.document) &&
                                                            subItem.data.document.length > 0
                                                          ) {
                                                            displaySubContents.push(subItem);
                                                          }
                                                        }
                                                        
                                                      }
                                                    }
                                                    item.content = displaySubContents;
                                                  }
                                                }
                                                // filter empty first level docs
                                                docs.content = docs.content.filter((doc: any) => {
                                                  return doc.content && doc.content.length > 0;
                                                });
                                              
                                            }
                                            return title === section;
                                          });

                                        }
                                      }
                                    },
                                    (err) => {
                                      //
                                    }
                                  )
                                );

                              }
                            });
                        } else {
                          this.toastrService.error(res.message);
                        }
                      },
                      (err) => {
                        // if we came here users with given userId do not exist
                      }
                    )
                );
              }
            }
          })
        );
      } else {
        const { documentId, section, subSection, structureId } =
          this.activatedRoute.snapshot.params;
        this.documentId = documentId;

        this.subscriptions.push(
          this.documentArchivesService.getQrcode(this.documentId).subscribe(
            (res) => {
              if (res.status) {
                this.documentArchive = res.data;
                this.propertyId = res.data.property;
                this.condoStructuresService
                  .getQrcode(res.data.structureId)
                  .subscribe((res) => {
                    if (res.status) {
                      this.condoStructure = res.data;
                      this.companyId = res.data.companyId;

                      this.subscriptions.push(
                        this.settingsService.getDocument().subscribe(
                          (res) => {
                            if (res.status) {
                              if (
                                res.data &&
                                Array.isArray(res.data) &&
                                res.data.length > 0 &&
                                res.data[0].area &&
                                Array.isArray(res.data[0].area)
                              ) {
                                this.documentTemplateId = res.data[0]._id;
                                this.documentTemplate = res.data[0].area;
        
                                this.allDocs = this.documentTypeStructure.getDocumentArchiveData(
                                  "it", // this.lang, 
                                  this.documentTemplate, 
                                  this.condoStructure, 
                                  this.documentArchive,
                                  "FULL", // this.subscriptionType,
                                  this.insertedDocs,
                                );

                                this.formUserData = true;
                                this.initForm();

                                this.displayedDocs = this.allDocs.filter((docs: any) => {
                                  const title = docs.keyTranslateTitle.replace("properties.documents.", "");
                                  // filter missing docs and deleted structure
                                  if (title === section) {
                                    
                                      const contents = docs.content;
                                      if (contents && Array.isArray(contents)) {
                                        for (const item of contents) {
                                          const subContents = item.content;
                                          const displaySubContents: any[] = [];
                                          if (subContents && Array.isArray(subContents)) {

                                            for (const subItem of subContents) {
                                              if (subItem.structureId && subItem.structureId !== ""){
                                                if (subItem.active) {
                                                  let subSubContent = subItem.content;
                                                  if (subSubContent && Array.isArray(subSubContent)) {
                                                    subSubContent = subSubContent.filter((subSubItem: any) => {
                                                      return !subSubItem.deleted &&
                                                      // !subSubItem.contract &&
                                                      !subSubItem.expired &&
                                                      subSubItem.data && 
                                                      subSubItem.data.document &&
                                                      Array.isArray(subSubItem.data.document) &&
                                                      subSubItem.data.document.length > 0;
                                                    });
                                                  }
                                                  if (subSubContent.length > 0) {
                                                    subItem.content = subSubContent;
                                                    displaySubContents.push(subItem); 
                                                  }
                                                }
                                              } else if (subItem.type === "title" && subItem.content && Array.isArray(subItem.content)) {
                                                const subSubContent = subItem.content.filter((subSubItem: any) => {
                                                  return !subSubItem.deleted &&
                                                    !subSubItem.expired &&
                                                    subSubItem.data &&
                                                    subSubItem.data.document &&
                                                    Array.isArray(subSubItem.data.document) &&
                                                    subSubItem.data.document.length > 0;
                                                });
                                                if (subSubContent.length > 0) {
                                                  subItem.content = subSubContent;
                                                  displaySubContents.push(subItem);
                                                }
                                              } else {
                                                if (
                                                  !subItem.deleted &&
                                                  // !subItem.contract &&
                                                  !subItem.expired &&
                                                  subItem.data &&
                                                  subItem.data.document &&
                                                  Array.isArray(subItem.data.document) &&
                                                  subItem.data.document.length > 0
                                                ) {
                                                  displaySubContents.push(subItem);
                                                }
                                              }
                                              
                                            }
                                          }
                                          item.content = displaySubContents;
                                        }
                                      }
                                      // filter empty first level docs
                                      docs.content = docs.content.filter((doc: any) => {
                                        return doc.content && doc.content.length > 0;
                                      });
                                    
                                  }
                                  return title === section;
                                });

                              }
                            }
                          },
                          (err) => {
                            //
                          }
                        )
                      );
                      
                    }
                  });
              } else {
                this.toastrService.error(res.message);
              }
            },
            (err) => {
              // if we came here users with given userId do not exist
            }
          )
        );
      }
    }

    if (this.isDoc) {
      const { documentId, doc, type, key, subdocid } =
        this.activatedRoute.snapshot.params;
      this.documentId = documentId;

      this.subscriptions.push(
        this.documentArchivesService.getQrcode(this.documentId).subscribe(
          (res) => {
            if (res.status) {
              this.documentArchive = res.data;
              this.propertyId = res.data.property;
              this.companyId = res.data.companyId;
            
              this.condoStructuresService
                .getQrcode(res.data.structureId)
                .subscribe((res) => {
                  if (res.status) {
                    this.condoStructure = res.data;

                    this.subscriptions.push(
                      this.settingsService.getDocument().subscribe(
                        (res) => {
                          if (res.status) {
                            if (
                              res.data &&
                              Array.isArray(res.data) &&
                              res.data.length > 0 &&
                              res.data[0].area &&
                              Array.isArray(res.data[0].area)
                            ) {
                              this.documentTemplateId = res.data[0]._id;
                              this.documentTemplate = res.data[0].area;
      
                              this.allDocs = this.documentTypeStructure.getDocumentArchiveData(
                                "it", // this.lang, 
                                this.documentTemplate, 
                                this.condoStructure, 
                                this.documentArchive,
                                "FULL", // this.subscriptionType,
                                this.insertedDocs,
                              );

                              this.formUserData = true;
                              this.initForm();

                              let subSection = "";
                              switch (doc) {
                                case "gest-amm-tivo-dipendenti":
                                  subSection = "gestAmmTivoDipendenti";
                                  break;
                                case "gest-amm-tivo-gestione-dipend":
                                  subSection = "gestAmmTivoGestioneDipend";
                                  break;
                                case "gest-amm-tivo-gestionali":
                                  subSection = "gestAmmTivoGestionali";
                                  break;
                                case "gest-amm-tivo-gestione-rifiut":
                                  subSection = "gestAmmTivoGestioneRifiut";
                                  break;
                                case "gest-amm-tivo-banca":
                                  subSection = "gestAmmTivoBanca";
                                  break;
                                case "gest-amm-tivo-cause-legali":
                                  subSection = "gestAmmTivoCauseLegali";
                                  break;
                                case "gest-amm-tivo-sicurezza":
                                  subSection = "gestAmmTivoSicurezza";
                                  break;
                                case "gest-amm-tivo-assicurazioni":
                                  subSection = "gestAmmTivoAssicurazioni";
                                  break;
                                case "gest-amm-tivo-valut-fornitori":
                                  subSection = "gestAmmTivoValutFornitori";
                                  break;
                                case "gest-amm-tivoatto-di-acqven":
                                  subSection = "gestAmmTivoattoDiAcqven";
                                  break;
                                case "gest-amm-tivovincoli-e-diri":
                                  subSection = "gestAmmTivovincoliEDiri";
                                  break;
                                case "gest-amm-tivoipoteche":
                                  subSection = "gestAmmTivoipoteche";
                                  break;
                                case "gest-amm-tivotitolarita":
                                  subSection = "gestAmmTivotitolarita";
                                  break;
                                case "gest-amm-elaborati-grafici":
                                  subSection = "gestAmmelaboratiGrafici";
                                  break;
                                case "gest-ammape":
                                  subSection = "gestAmmApe";
                                  break;
                                case "catasto-catasto-terreni":
                                  subSection = "catastoCatastoTerreni";
                                  break;
                                case "catasto-catasto-fabbricati":
                                  subSection = "catastoCatastoFabbricati";
                                  break;
                                case "urbedilurbanisted-edili":
                                  subSection = "urbedilurbanistedEdili";
                                  break;
                                case "urbedilcondoni":
                                  subSection = "urbedilcondoni";
                                  break;
                                case "urbedilautorizzazioni":
                                  subSection = "urbedilautorizzazioni";
                                  break;
                                case "stacking-plan":
                                  subSection = "stackingPlan";
                                  break;
                                case "reportistica":
                                  subSection = "reportistica";
                                  break;
                                case "locazione-contrdi-locazione":
                                  subSection = "locazioneContrdiLocazione";
                                  break;
                                case "contratti":
                                  subSection = "contratti";
                                  break;
                                case "linea-vita":
                                  subSection = "lineaVita";
                                  break;
                                case "amianto":
                                  subSection = "amiantoDoc";
                                  break;
                                case "edile-documenti-di-costruz-":
                                  subSection = "ediledocumentiDiCostruz";
                                  break;
                                case "edile-murature-rei":
                                  subSection = "edilemuratureRei";
                                  break;
                                case "edile-porte-rei":
                                  subSection = "edileporteRei";
                                  break;
                                case "edile-interventi-successivi":
                                  subSection = "edileinterventiSuccessivi";
                                  break;
                                case "edile-strutture":
                                  subSection = "edilestrutture";
                                  break;
                                case "edile-rete-fognaria":
                                  subSection = "edilereteFognaria";
                                  break;
                                case "impelegenerale":
                                  subSection = "impelegenerale";
                                  break;
                                case "impele-media-tensione":
                                  subSection = "impeleMediaTensione";
                                  break;
                                case "impele-gruppo-elettrogeno":
                                  subSection = "impeleGruppoElettrogeno";
                                  break;
                                case "impele-fotovoltaico":
                                  subSection = "impeleFotovoltaico";
                                  break;
                                case "impelescariche-atmosferiche":
                                  subSection = "impelescaricheAtmosferiche";
                                  break;
                                case "riscaldrisccentraliz":
                                  subSection = "riscaldrisccentraliz";
                                  break;
                                case "serbatoio-a-gasolio":
                                  subSection = "serbatoioAGasolio";
                                  break;
                                case "riscaldgas-metcontatrete":
                                  subSection = "riscaldgasMetcontatrete";
                                  break;
                                case "riscaldsottostazriscaldamen":
                                  subSection = "riscaldsottostazriscaldamen";
                                  break;
                                case "riscaldcanne-fumarie-per-ct":
                                  subSection = "riscaldcanneFumariePerCt";
                                  break;
                                case "riscaldsolare-termico":
                                  subSection = "riscaldsolareTermico";
                                  break;
                                case "riscaldcentrteleriscaldamen":
                                  subSection = "riscaldcentrteleriscaldamen";
                                  break;
                                case "risc-geotermico-pozzi":
                                  subSection = "riscGeotermicoPozzi";
                                  break;
                                case "risc-geotermico-sonde":
                                  subSection = "riscGeotermicoSonde";
                                  break;
                                case "riscaldsolo-pompe-di-calore":
                                  subSection = "riscaldsoloPompeDiCalore";
                                  break;
                                case "riscaldcentr-ricev-bsc":
                                  subSection = "riscaldcentrRicevBsc";
                                  break;
                                case "riscaldimpcondizionamento":
                                  subSection = "riscaldimpcondizionamento";
                                  break;
                                case "risccanne-fumarie-coll-":
                                  subSection = "risccanneFumarieColl";
                                  break;
                                case "ascensori-e-montauto-ascensori":
                                  subSection = "ascensoriEMontautoAscensori";
                                  break;
                                case "ascensori-e-montauto-montauto-":
                                  subSection = "ascensoriEMontautoMontauto";
                                  break;
                                case "trat-acqua-contatore-acqua":
                                  subSection = "tratAcquaContatoreAcqua";
                                  break;
                                case "trat-acqua-centrale-idrica":
                                  subSection = "tratAcquaCentraleIdrica";
                                  break;
                                case "trat-acqua-sott-alim-da-bsc":
                                  subSection = "tratAcquaSottAlimDaBsc";
                                  break;
                                case "trat-acqua-pomp-sollacqpiov":
                                  subSection = "tratAcquaPompSollacqpiov";
                                  break;
                                case "trat-acqua-rete-idrica-sanitari":
                                  subSection = "tratAcquaReteIdricaSanitari";
                                  break;
                                case "imp-elettronici-tv-terrestre":
                                  subSection = "impElettronicitvTerrestre";
                                  break;
                                case "imp-elettronici-tv-satellitare":
                                  subSection = "impElettronicitvSatellitare";
                                  break;
                                case "imp-elettronici-automazioni":
                                  subSection = "impElettroniciautomazioni";
                                  break;
                                case "imp-elettronici-imp-citofonico":
                                  subSection = "impElettroniciimpCitofonico";
                                  break;
                                case "imp-elettronici-impianto-tvcc":
                                  subSection = "impElettroniciimpiantoTvcc";
                                  break;
                                case "imp-elettronici-antintrusione":
                                  subSection = "impElettroniciantintrusione";
                                  break;
                                case "vv-fdefinitivo":
                                  subSection = "vvFdefinitivo";
                                  break;
                                case "sicurezza-antincendio-facciate":
                                  subSection = "sicurezzaAntincendioFacciate";
                                  break;
                                case "incendio-estintori-":
                                  subSection = "incendioEstintori";
                                  break;
                                case "incendio-rete-idranti":
                                  subSection = "incendioReteIdranti";
                                  break;
                                case "incendio-rete-sprinkler":
                                  subSection = "incendioReteSprinkler";
                                  break;
                                case "incendio-stazione-pompaggio":
                                  subSection = "incendioStazionePompaggio";
                                  break;
                                case "incendio-rilevazione":
                                  subSection = "incendioRilevazione";
                                  break;
                                case "incendio-ventilazione":
                                  subSection = "incendioVentilazione";
                                  break;
                                case "incendio-evac":
                                  subSection = "incendioEvac";
                                  break;
                                case "impianti-speciali":
                                  subSection = "impiantiSpeciali";
                                  break;
                                case "impricreativi-piscina":
                                  subSection = "impricreativipiscina";
                                  break;
                                case "impricreativi-palestra":
                                  subSection = "impricreativipalestra";
                                  break;
                                case "impricreativi-campo-tennis":
                                  subSection = "impricreativicampoTennis";
                                  break;
                                case "impricreativi-campo-calcio":
                                  subSection = "impricreativicampoCalcio";
                                  break;
                                case "impricreativi-parco-giochi":
                                  subSection = "impricreativiparcoGiochi";
                                  break;
                                case "unitaimmvvf":
                                  subSection = "unitaimmvvf";
                                  break;
                                case "unita-immdoc-amm-":
                                  subSection = "unitaImmdocAmm";
                                  break;
                                case "unitaimmelettrico":
                                  subSection = "unitaimmelettrico";
                                  break;
                                case "unitaimmantintrusione":
                                  subSection = "unitaimmantintrusione";
                                  break;
                                case "unitaimmidrico-sanitari":
                                  subSection = "unitaimmidricoSanitari";
                                  break;
                                case "unitaimmtermico":
                                  subSection = "unitaimmtermico";
                                  break;
                                case "unitaimmcondizionamento":
                                  subSection = "unitaimmcondizionamento";
                                  break;
                                case "unitaimmape":
                                  subSection = "unitaimmape";
                                  break;
                                case "unitaimmelaborati-grafici":
                                  subSection = "unitaimmelaboratiGrafici";
                                  break;
                                case "unitaimmcanne-fumarie-per-":
                                  subSection = "unitaimmcanneFumariePer";
                                  break;
                                case "unita-immsicurezza":
                                  subSection = "unitaImmsicurezza";
                                  break;
                                default:
                                  subSection = doc;
                              }
                              this.displayedDocs = this.allDocs.filter((docs: any) => {
                                const contents = docs.content;
                                if (contents && Array.isArray(contents)) {
                                  for (const item of contents) {
                                    if (item && item.keyTranslateTitle ) {
                                    
                                      const title = item.keyTranslateTitle.replace("properties.documents.", "");
                                      // filter missing docs and deleted structure
                                      if (title === subSection) {
                                        const subContents = item.content;
                                        const displaySubContents: any[] = [];
                                        if (subContents && Array.isArray(subContents)) {

                                          for (const subItem of subContents) {
                                            if (
                                              (subItem.structureId && subItem.structureId !== "") || 
                                              subSection === 'edileinterventiSuccessivi' ||
                                              subSection === 'gestAmmTivoCauseLegali' || 
                                              subSection === 'gestAmmTivoValutFornitori' || 
                                              subSection === 'locazioneContrdiLocazione'
                                            ){
                                              if (
                                                subItem.active || 
                                                subSection === 'edileinterventiSuccessivi' ||
                                                subSection === 'gestAmmTivoCauseLegali' || 
                                                subSection === 'gestAmmTivoValutFornitori' || 
                                                subSection === 'locazioneContrdiLocazione'
                                              ) {
                                                let subSubContent = subItem.content;
                                                if (subSubContent && Array.isArray(subSubContent)) {
                                                  subSubContent = subSubContent.filter((subSubItem: any) => {
                                                    return subSubItem.docId.toString() === subdocid && 
                                                    !subSubItem.deleted &&
                                                    // !subSubItem.contract &&
                                                    !subSubItem.expired &&
                                                    subSubItem.data && 
                                                    subSubItem.data.document &&
                                                    Array.isArray(subSubItem.data.document) &&
                                                    subSubItem.data.document.length > 0;
                                                  });
                                                }
                                                if (subSubContent.length > 0) {
                                                  subItem.content = subSubContent;
                                                  displaySubContents.push(subItem); 
                                                }
                                              }
                                            } else {
                                              if (
                                                subItem &&
                                                subItem.docId && 
                                                subItem.docId.toString() === subdocid && 
                                                !subItem.deleted &&
                                                // !subItem.contract &&
                                                !subItem.expired &&
                                                subItem.data && 
                                                subItem.data.document &&
                                                Array.isArray(subItem.data.document) &&
                                                subItem.data.document.length > 0
                                              ) {
                                                displaySubContents.push(subItem); 
                                              }
                                            }
                                            
                                          }
                                        }
                                        item.content = displaySubContents;
                                      } else {
                                        item.content = [];
                                      }

                                    } else {
                                      // unità immobiliari
                                      const subContents = item.content;
                                      const displaySubContents: any[] = [];
                                      if (subContents && Array.isArray(subContents)) {

                                        for (const subItem of subContents) {
                                          const title = subItem.keyTranslateTitle.replace("properties.documents.", "");
                                          // filter missing docs and deleted structure
                                          if (title === subSection) {
                                            if (subItem.structureId && subItem.structureId !== ""){
                                              if (subItem.active) {
                                                let subSubContent = subItem.content;
                                                if (subSubContent && Array.isArray(subSubContent)) {
                                                  subSubContent = subSubContent.filter((subSubItem: any) => {
                                                    return subSubItem.docId.toString() === subdocid && 
                                                    !subSubItem.deleted &&
                                                    // !subSubItem.contract &&
                                                    !subSubItem.expired &&
                                                    subSubItem.data && 
                                                    subSubItem.data.document &&
                                                    Array.isArray(subSubItem.data.document) &&
                                                    subSubItem.data.document.length > 0;
                                                  });
                                                }
                                                if (subSubContent.length > 0) {
                                                  subItem.content = subSubContent;
                                                  displaySubContents.push(subItem); 
                                                }
                                              }
                                            } else {
                                              if (
                                                subItem &&
                                                subItem.docId &&  
                                                subItem.docId.toString() === subdocid && 
                                                !subItem.deleted &&
                                                // !subItem.contract &&
                                                !subItem.expired &&
                                                subItem.data && 
                                                subItem.data.document &&
                                                Array.isArray(subItem.data.document) &&
                                                subItem.data.document.length > 0
                                              ) {
                                                displaySubContents.push(subItem); 
                                              }
                                            }
                                          }
                                        }
                                      }
                                      item.content = displaySubContents;
                                    }

                                  }
                                }
                                // filter empty first level docs
                                docs.content = docs.content.filter((doc: any) => {
                                  return doc.content && doc.content.length > 0;
                                });
                                  
                                // }
                                // return title === section;
                                return docs.content.length > 0;
                              });

                            }
                          }
                        },
                        (err) => {
                          //
                        }
                      )
                    );

                    
                  }
                });

            } else {
              this.toastrService.error(res.message);
            }
          },
          (err) => {
            // if we came here users with given userId do not exist
          }
        )
      );

    }
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Init form
   *
   * @since 1.0.0
   */
  initForm(): void {
    // Set model
    this.model = {
      firstName: this.firstName,
      lastName: this.lastName,
      company: this.companyName,
    };

    // Set fields
    this.fields = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-12",
            type: "input",
            key: "firstName",
            templateOptions: {
              label: this.translateService.instant(
                "qrcode.viewPage.form.firstName.label"
              ),
              placeholder: this.translateService.instant(
                "qrcode.viewPage.form.firstName.placeholder"
              ),
              required: true,
              maxLength: 320,
            },
            defaultValue: this.firstName,
          },
          {
            className: "col-12",
            type: "input",
            key: "lastName",
            templateOptions: {
              label: this.translateService.instant(
                "qrcode.viewPage.form.lastName.label"
              ),
              placeholder: this.translateService.instant(
                "qrcode.viewPage.form.lastName.placeholder"
              ),
              required: true,
              maxLength: 320,
            },
            defaultValue: this.lastName,
          },
          {
            className: "col-12",
            type: "input",
            key: "company",
            templateOptions: {
              label: this.translateService.instant(
                "qrcode.viewPage.form.company.label"
              ),
              placeholder: this.translateService.instant(
                "qrcode.viewPage.form.company.placeholder"
              ),
              required: false,
              maxLength: 320,
            },
            defaultValue: this.companyName,
          },
        ],
      },
    ];

    if (this.forceSubmit) {
      this.onFormSubmit(this.model);
    }
  }

  /**
   * Handle form submit
   *
   * @since 1.0.0
   */
  onFormSubmit(model: any): void {
    // Prevent invalid form submit
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsTouched();
      });
      return;
    }
    // Activate submit button loading status
    this.formBtnOptions.active = true;

    if (this.isVideo) {
      // const params = {
      //   firstName: model.firstName,
      //   lastName: model.lastName,
      //   company: model.company,
      // };
      // this.subscriptions.push(
      //   this.propertiesService
      //     .setVideoVisit(this.propertyId, params)
      //     .pipe(finalize(() => (this.formBtnOptions.active = false)))
      //     .subscribe(
      //       (res) => {
      //         if (res.status) {
      //           this.formUserData = false;
      //           this.showVideo = true;

      //           return;
      //         }
      //       },
      //       (err) => {
      //         // Choose one of the following error handling method.
      //         // 1) First one show a message right under the form fields
      //         //    (if the form is properly setted)
      //         // 2) Second one is used to show a mat-error under each field
      //         //    in the dynamic form (is meant to be used only in dynamicForm)
      //         // 3) Third one show toastr notifications for each error
      //         // 4) Fourth one is used to show mat-error under each field
      //         //    in the ngx-formly form (is mean to be used only with ngx-formly)
      //         // this.helperService.handleFormError(form, err);
      //         // this.helperService.handleDynamicFormError(form, err);
      //         // this.helperService.handleError(err);
      //         this.helperService.handleFormlyError(this.form, err);
      //       }
      //     )
      // );

      this.formUserData = false;
      this.showVideo = true;
    }

    if (this.isSafetyVideoResidents || this.isSafetyVideoSuppliers) {
      const params: VideoViewInterface = {
        companyId: this.companyId,
        type: this.isSafetyVideoResidents ? 'resident' : 'supplier',
        firstName: model.firstName,
        lastName: model.lastName,
        companyName: model.company,
      };
      this.subscriptions.push(
        this.videoViewService
          .create(params)
          .pipe(finalize(() => (this.formBtnOptions.active = false)))
          .subscribe(
            (res) => {
              if (res.status) {
                this.formUserData = false;
                if (this.isSafetyVideoResidents) {
                  this.showVideoResident = true;
                } else if (this.isSafetyVideoSuppliers) {
                  this.showVideoSupplier = true;
                }

                return;
              }
            },
            (err) => {
              // Choose one of the following error handling method.
              // 1) First one show a message right under the form fields
              //    (if the form is properly setted)
              // 2) Second one is used to show a mat-error under each field
              //    in the dynamic form (is meant to be used only in dynamicForm)
              // 3) Third one show toastr notifications for each error
              // 4) Fourth one is used to show mat-error under each field
              //    in the ngx-formly form (is mean to be used only with ngx-formly)
              // this.helperService.handleFormError(form, err);
              // this.helperService.handleDynamicFormError(form, err);
              // this.helperService.handleError(err);
              this.helperService.handleFormlyError(this.form, err);
            }
          )
      );
    }

    if (this.isDoc || this.isDocsSection) {
      this.subscriptions.push(
        this.accessLogsService
          .Qrcode(
            "external",
            "web",
            model.firstName,
            model.lastName,
            model.company,
            this.companyId
          )
          .pipe(finalize(() => (this.formBtnOptions.active = false)))
          .subscribe(
            (res) => {
              if (res.status) {
                this.formUserData = false;

                if (this.isDoc) {
                  this.showDoc = true;
                }
                if (this.isDocsSection) {
                  this.showDocSection = true;
                }

                return;
              }
            },
            (err) => {
              this.helperService.handleFormlyError(this.form, err);
            }
          )
      );
    }
  }

  /**
   * Utility: extracts documents from one section of documentArchive
   * and show the documents into page
   * in getDocumentArchiveData()
   *
   * array of documents
   *
   * @since 1.0.0
   */
  getDocsFromSection(section): any {
    const docList = [];
    for (const doc in section.documents) {
      if (section.documents[doc].length) {
        section.documents[doc].forEach((item: any) => {
          if (!item.deleted && item.data /* && !item.contract */ && !item.expired) {
            docList.push({
              title: this.translateService.instant(
                "properties.documents.titles." + doc
              ),
              type: "doc",
              docId: item._id,
              key: doc,
              mandatory: item.mandatory,
              expired: item.expired,
              deleted: item.deleted,
              dateExpired: item.dateExpired,
              contract: item.contract,
              pdfmsg: item.pdfmsg,
              data: item.data,
              checked: false,
            });
          }
        });
      }
    }

    // docList.sort(this.compareExpired);
    return docList;
  }

  /**
   * Utility: extracts single document from one section of documentArchive
   * and show the documents into page
   * in getDocumentArchiveData()
   *
   * array of documents
   *
   * @since 1.0.0
   */
  getSingleDocFromSection(section, type, key, subdocId): any {
    const docList = [];
    for (const doc in section.documents) {
      if (doc === key) {
        if (section.documents[doc].length) {
          section.documents[doc].forEach((item: any) => {
            if (item._id.toString() === subdocId.toString()) {
              if (
                !item.deleted &&
                item.data &&
                // !item.contract &&
                !item.expired
              ) {
                docList.push({
                  title: this.translateService.instant(
                    "properties.documents.titles." + doc
                  ),
                  type: "doc",
                  docId: item._id,
                  key: doc,
                  mandatory: item.mandatory,
                  expired: item.expired,
                  deleted: item.deleted,
                  dateExpired: item.dateExpired,
                  contract: item.contract,
                  pdfmsg: item.pdfmsg,
                  data: item.data,
                  checked: false,
                });
              }
            }
          });
        }
      }
    }

    // docList.sort(this.compareExpired);
    return docList;
  }

  /**
   * Handle click on document form to download file
   * itemData: data value of form items
   *
   * @since 1.0.0
   */
  onToggleDownloadDocument(documents: any): void {
    if (!documents || !documents.length) {
      console.warn("ERROR: NO DOCS");
      return;
    }
    const dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
      data: {
        propertyId: this.propertyId,
        documents,
      },
      width: "600px",
    });
  }

  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };

  /**
   * Handle table sort
   *
   * @since 1.0.0
   */
  sortData(sort: Sort, i: string, t: string, x: string, pos: string): any {
    let sortedData = [];
    if (pos === "1") {
      sortedData = this.displayedDocs[i].content[t].content[x].content;
    } else if (pos === "2") {
      sortedData = this.displayedDocs[i].content[t].content;
    } else if (pos === "3") {
      sortedData = this.displayedDocs[i].content;
    }

    if (!this.sortActive) {
      this.currentOriginalOrder = JSON.parse(JSON.stringify(sortedData));
    }

    const data = sortedData;
    if (!sort.active || sort.direction === "") {
      sortedData = this.currentOriginalOrder;
      if (pos === "1") {
        this.displayedDocs[i].content[t].content[x].content = sortedData;
      } else if (pos === "2") {
        this.displayedDocs[i].content[t].content = sortedData;
      } else if (pos === "3") {
        this.displayedDocs[i].content = sortedData;
      }
      this.sortActive = false;
      return;
    }

    sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "title":
          return this.compare(
            a.title.toLowerCase(),
            b.title.toLowerCase(),
            isAsc
          );
        case "data.contenutoDocumento":
          const aContenutoDocumento =
            a.data && a.data.contenutoDocumento
              ? a.data.contenutoDocumento.toLowerCase()
              : "";
          const bContenutoDocumento =
            b.data && b.data.contenutoDocumento
              ? b.data.contenutoDocumento.toLowerCase()
              : "";
          return this.compare(aContenutoDocumento, bContenutoDocumento, isAsc);
        case "data.ragioneSocialeFornitore":
          const aRagioneSocialeFornitore =
            a.data && a.data.ragioneSocialeFornitore
              ? a.data.ragioneSocialeFornitore
              : "";
          const bRagioneSocialeFornitore =
            b.data && b.data.ragioneSocialeFornitore
              ? b.data.ragioneSocialeFornitore
              : "";
          return this.compare(
            aRagioneSocialeFornitore,
            bRagioneSocialeFornitore,
            isAsc
          );
        case "data.dataDocumento":
          const aDataDocumento =
            a.data && a.data.dataDocumento ? a.data.dataDocumento : "";
          const bDataDocumento =
            b.data && b.data.dataDocumento ? b.data.dataDocumento : "";
          return this.compare(aDataDocumento, bDataDocumento, isAsc);
        case "dateExpired":
          const aDateExpired = a.dateExpired ? a.dateExpired : "";
          const bDateExpired = b.dateExpired ? b.dateExpired : "";
          return this.compare(aDateExpired, bDateExpired, isAsc);
        default:
          return 0;
      }
    });

    if (pos === "1") {
      this.displayedDocs[i].content[t].content[x].content = sortedData;
    } else if (pos === "2") {
      this.displayedDocs[i].content[t].content = sortedData;
    } else if (pos === "3") {
      this.displayedDocs[i].content = sortedData;
    }

    this.sortActive = true;
  }

  /**
   * Utility per table sort
   *
   * @since 1.0.0
   */
  compare(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean
  ): any {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
